import React, { useReducer } from 'react';
import { useToasts } from 'react-toast-notifications'
import { errorToast} from '../../utils/ToastUtil'

import SalarySettlementContext from './SalarySettlementContext'
import SalarySettlementReducer from './SalarySettlementReducer'

import {getFileLiquidation} from '../../http_services/salarySettlement/index';

import { 
    LOADING
} from "../../types";

const SalarySettlementState = (props) => {
    
    const { addToast } = useToasts();

    const initialState = {
        loading: false,
        error: null,
        loadingFile: false,
        user: null,
        file: null
    }

    // eslint-disable-next-line no-unused-vars
    const [state, dispatch] = useReducer(SalarySettlementReducer, initialState);

    const downloadLiquidation = async(nameFile) => {
        try{
            loading()
            const res = await getFileLiquidation(nameFile);
            loading()
            return res;
        }catch(err){
            loading()
            addToast('Error al obtener el archivo', errorToast());
        }
    }

    const loading = () => {
        dispatch({
          type: LOADING
        });
      }

    return ( 
        <SalarySettlementContext.Provider
            value={{
                downloadLiquidation: downloadLiquidation
            }}
        >
           {props.children}
        </SalarySettlementContext.Provider>
     );
}
 
export default SalarySettlementState;